import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-课程管理",
  "use": "icon-课程管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-课程管理\">\n<path d=\"M147 128C147 134.075 142.075 139 136 139L24 139C17.9249 139 13 134.075 13 128L13 32C13 25.9249 17.9249 21 24 21L136 21C142.075 21 147 25.9249 147 32L147 128Z\" stroke-width=\"10\" />\n<path d=\"M147 128C147 134.075 142.075 139 136 139L22 139C17.0294 139 13 134.971 13 130L13 115.4L147 115.4L147 128Z\" stroke-width=\"10\" />\n<path d=\"M106.647 64.7497C109.802 66.7048 109.802 71.2952 106.647 73.2503L74.1334 93.3955C70.8026 95.4593 66.5 93.0637 66.5 89.1452L66.5 48.8548C66.5 44.9363 70.8026 42.5407 74.1335 44.6045L106.647 64.7497Z\" stroke-width=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/课程管理.svg
// module id = pGmm
// module chunks = 26